import { jsPDF } from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import { CircularProgress, Grid, Icon } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import { gql, useLazyQuery } from "@apollo/client";
import EmpleadoLayout from "components/LayoutContainers/EmpleadoLayout";
import boxShadows from "assets/theme/base/boxShadows";
import EditableText from "components/EditableText";
import PdfHeader from "../components/pdfHeader";
import { formatMoneyPunto } from "utils/formatters";

const textosIniciales = [
  " ", // Número
  " ", // Solicitud N°
  " ", // Expediente
  "--/--/--", // Fecha Evaluación
];

const RankingProcesoContratacion = () => {
  const documentsRef = useRef(null);
  const { id } = useParams();
  const { lg } = boxShadows;

  const [textArray, setTextArray] = useState(textosIniciales);
  const [editable, setEditable] = useState(true);

  const [data, setData] = useState(null);
  // El ranking se arma en el servidor: solo posiciones, precios y número de
  // oferente, sin datos que identifiquen a los demás proveedores.
  const [getPedido, { loading, error }] = useLazyQuery(
    gql`
      query getRankingPedidoCompra($id: ID!) {
        rankingPedidoCompra(idPedidoCompra: $id) {
          id
          numeroExpediente
          licitacionFin
          renglones {
            id
            numero
            descripcion
            cantidad
            unidad
            equivalencia
            ofertas {
              posicion
              proveedorNumero
              detalle
              alternativo
              precio
              total
              propia
            }
          }
        }
      }
    `,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data?.rankingPedidoCompra) return;
        setData(data.rankingPedidoCompra);
      },
    }
  );

  useEffect(() => {
    if (id) {
      getPedido({ variables: { id } });
    }
  }, [id]);

  useEffect(() => {
    if (data) {
      const newTextArray = [...textArray];
      newTextArray[0] = data.id;
      newTextArray[1] = data.id;

      const fechaCierre = data.licitacionFin ? new Date(data.licitacionFin).toLocaleDateString() : "--/--/--";
      newTextArray[3] = fechaCierre;  // Fecha Evaluación (o Cierre)

      setTextArray(newTextArray);
    }
  }, [data]);

  const handleGeneratePdf = async () => {
    setEditable(false);
    const document = documentsRef.current;
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: "landscape",
      hotfixes: ["px_scaling"],
      compress: true,
    });

    // Define el footer con el número de página
    const addFooter = (doc, currentPage, totalPages) => {
      doc.setFontSize(8);
      doc.text(`Página ${currentPage} de ${totalPages}`, doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 10, {
        align: "center",
      });
    };

    // Genera el contenido principal en el PDF
    await doc.html(document, {
      margin: [40, 0, 40, 0],
      autoPaging: "text",
      callback: async function (doc) {
        const totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          addFooter(doc, i, totalPages);
        }

        // Guarda el archivo PDF
        doc.save(`exd-PedidoNro-${data.id}-ranking-proceso-contratación.pdf`);
      },
    });

    setEditable(true);
  };

  const handleTextChange = (e, index) => {
    const newTextArray = [...textArray];
    newTextArray[index] = e.target.innerText;
    setTextArray(newTextArray);
  };

  if (!data) return (
    <EmpleadoLayout>
      <SoftBox display="flex" justifyContent="center" alignItems="center" height="100vh" flexDirection="column" gap={3}>
        {loading ? (<>
          <CircularProgress size={40} color="primary" />
          <SoftTypography variant="h5">Cargando</SoftTypography>
        </>) : (<>
          <Icon fontSize="large">{error ? "lock" : "search_off"}</Icon>
          <SoftTypography variant="h5">{error ? error.message : "No se encontró el pedido"}</SoftTypography>
        </>)}
      </SoftBox>
    </EmpleadoLayout>
  );
  return (
    <EmpleadoLayout>
      <SoftBox
        p={2}
        display="flex"
        alignItems="center"
        flexDirection="column"
        minHeight="100vh"
        height="100%"
      >
        <div ref={documentsRef}>
          <SoftBox
            sx={{
              position: "relative",
              overflow: "hidden",
              width: "1123px",
              backgroundColor: "#ffffff",
              boxShadow: lg,
              px: 6,
            }}
            pb={5}
          >
            {/* ACA VA TODO EL CODIGO */}
            <PdfHeader />
            <SoftBox display="flex" flexDirection="column" gap={2} lineHeight={1.5} fontSize="12px">
              <Grid
                container
                border="1pt solid black"
                sx={{ '& > *:not(:last-child)': { borderBottom: "1pt solid black" } }}
              >
                <Grid item xs={12} fontWeight="bold" px={35} py={1} textAlign="center">
                  RANKING DE EVALUACIÓN DE PROCESO DE CONTRATACIÓN N°:{" "}
                  <EditableText
                    tooltip="Número"
                    //editable={editable}
                    content={textArray[0]}
                    handleOnBlur={(e) => handleTextChange(e, 0)}
                  />
                  {" "}CONCURSO DE PRECIOS OTROS ORGANISMOS
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sx={{
                    '& > *:not(:last-child)': { borderRight: "1pt solid black" },
                    '& > *:nth-child(odd)': { backgroundColor: "#f0f0f0", fontWeight: "bold" },
                  }}
                >
                  <Grid item xs={2} px={1}>Método de Adjudicación </Grid>
                  <Grid item xs={10} px={1}>POR ITEM INDIVIDUAL AL MENOR PRECIO OFERTADO</Grid>
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sx={{
                    '& > *:not(:last-child)': { borderRight: "1pt solid black" },
                    '& > *:nth-child(odd)': { backgroundColor: "#f0f0f0", fontWeight: "bold" },
                  }}
                >
                  <Grid item xs={2} px={1}>Solicitud N° </Grid>
                  <Grid item xs={2} px={1}>
                    <EditableText
                      tooltip="Solicitud N°"
                      //editable={editable}
                      content={textArray[1]}
                      handleOnBlur={(e) => handleTextChange(e, 1)}
                    />
                  </Grid>
                  <Grid item xs={2} px={1}>Fecha</Grid>
                  <Grid item xs={2} px={1}>
                    <EditableText
                      tooltip="Fecha"
                      //editable={editable}
                      content={textArray[3]}
                      handleOnBlur={(e) => handleTextChange(e, 3)}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sx={{
                    '& > *:not(:last-child)': { borderRight: "1pt solid black" },
                    '& > *:nth-child(odd)': { backgroundColor: "#f0f0f0", fontWeight: "bold" },
                  }}>
                  <Grid item xs={2} px={1}>Unidad Solicitante </Grid>
                  <Grid item xs={10} px={1}>{"UNIVERSIDAD PROVINCIAL DE OFICIOS \"EVA PERON\""}</Grid>
                </Grid>
              </Grid>

              <SoftTypography variant="h6">Cotizaciones Evaluadas por Items</SoftTypography>

              <SoftBox sx={{ '& > *': { borderTop: "1px solid gray" } }}>
                {data?.renglones.map((detalle, index) => (
                  <SoftBox key={index}>
                    <Grid
                      container
                      backgroundColor="#f0f0f0"
                      textAlign="center"
                      fontWeight="bold"
                    >
                      <Grid item container xs={5}>
                        <Grid item xs={3} px={1}>Item</Grid>
                        <Grid item xs={6} px={1}>Descripción</Grid>
                        <Grid item xs={3} px={1}>Cantidad</Grid>
                      </Grid>
                      <Grid item container xs={7}>
                        <Grid item xs={2} px={1}>Rnk</Grid>
                        <Grid item xs={2} px={1}>Proveedor</Grid>
                        <Grid item xs={4} px={1}>Marca / Modelo / Observación</Grid>
                        <Grid item xs={2} px={1}>Monto Unitario</Grid>
                        <Grid item xs={2} px={1}>Total Cotizado</Grid>
                      </Grid>
                    </Grid>
                    <Grid container>
                      {/* data producto */}
                      <Grid item container xs={5}>
                        <Grid item xs={3} px={1} textAlign="center">{detalle.numero}</Grid>
                        <Grid item xs={6} pl={1}>{detalle.descripcion}<br />{detalle.equivalencia}</Grid>
                        <Grid item xs={3} px={1} textAlign="center">{detalle.cantidad} {detalle.unidad}</Grid>
                      </Grid>
                      {/* data proveedores */}
                      <Grid item container xs={7} sx={{ '& > :nth-child(even)': { backgroundColor: "#f0f0f0" } }}>
                        {detalle.ofertas.map((oferta) => (
                          <Grid key={oferta.posicion} item container fontWeight={oferta.propia ? "bold" : "regular"}>
                            <Grid item xs={2} px={1} textAlign="center">{oferta.posicion}</Grid>
                            <Grid item xs={2} px={1}>
                              Proveedor N° {oferta.proveedorNumero ?? "N/A"}{oferta.propia ? " (su oferta)" : ""}
                            </Grid>
                            <Grid item xs={4} px={1}>
                              {[oferta.detalle, oferta.alternativo ? "(Alternativo)" : null].filter(e => e).join(" ") || "-"}
                            </Grid>
                            <Grid item xs={2} px={1} textAlign="right">$ {formatMoneyPunto(oferta.precio)}</Grid>
                            <Grid item xs={2} px={1} textAlign="right">$ {formatMoneyPunto(oferta.total)}</Grid>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </SoftBox>
                ))}
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </div>
        <SoftBox
          hidden={!editable}
          variant="contained"
          bgColor="white"
          p={2}
          style={{
            position: "fixed",
            bottom: "1.5rem",
            right: "1.5rem",
            zIndex: 1000,
            boxShadow:
              "inset 0rem 0rem 0.0625rem 0.0625rem rgb(255 255 255 / 90%), 0rem 1.25rem 1.6875rem 0rem rgb(0 0 0 / 5%)",
            borderRadius: "16px",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: `saturate(200%) blur(${pxToRem(30)})`,
          }}
        >
          <Grid container spacing={2} justifyContent="flex-end" id="button">
            <Grid item>
              <SoftButton variant="gradient" color="error" onClick={handleGeneratePdf}>
                <Icon fontWeight="bold">picture_as_pdf</Icon>
                &nbsp;&nbsp;Descargar PDF
              </SoftButton>
            </Grid>
          </Grid>
        </SoftBox>
      </SoftBox>
    </EmpleadoLayout>
  );
};

export default RankingProcesoContratacion; 
